import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { NgxSpinnerModule } from "ngx-spinner"; // Assuming you still use this
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html", // Make sure these paths are correct for your standalone component
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, NgxSpinnerModule],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly deviceService: DeviceDetectorService,
    private readonly router: Router,
  ) {
    if (
      !this.deviceService.isDesktop() &&
      !window.location.pathname.toLowerCase().startsWith("/batterypass")
    ) {
      // Redirect to the sign-out route
      // Ensure this path '/app/sign-out' correctly triggers your sign-out logic
      //this.router.navigateByUrl("/app/sign-out");
      this.router.navigateByUrl("/device-not-supported");
      console.log(
        "AppComponent: Non-desktop device detected, redirecting to sign-out.",
      );
    }
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // This fires on every route change
        const globalDataLayer = globalThis as typeof globalThis & {
          dataLayer: Array<Record<string, unknown>>;
        };

        const userId = this.getCurrentUserId();
        const pageViewPayload: Record<string, unknown> = {
          event: "virtualPageView",
          pageUrl: event.urlAfterRedirects,
          pageTitle: document.title,
        };

        if (userId) {
          pageViewPayload.user_id = userId;
        }

        globalDataLayer.dataLayer = globalDataLayer.dataLayer || [];
        globalDataLayer.dataLayer.push(pageViewPayload);
        console.log(pageViewPayload);
      }
    });
  }

  private getCurrentUserId(): string | null {
    const cachedUserRaw = localStorage.getItem("loggedInUser");

    if (!cachedUserRaw) {
      return null;
    }

    try {
      const cachedUser = JSON.parse(cachedUserRaw) as {
        id?: string;
        userId?: string;
      };
      const resolvedId = String(cachedUser.id ?? cachedUser.userId ?? "").trim();
      return resolvedId || null;
    } catch {
      return null;
    }
  }
}
